import * as React from 'react';
import { IEvent } from '../../custom/classes/event';
import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { ICalendarAppText } from '../../custom/classes/calendar-text';

import { connect } from 'react-redux';

import ListEventView from 'list-event.view';
import { ICalendarAppState } from '../../redux-state';

interface IListEventExternalProps {
    event: IEvent;
}

interface StateToProps {
    text: ICalendarAppText;
}

export type ListEventProps = IListEventExternalProps & StateToProps;

export const ListEventBase: React.StatelessComponent<ListEventProps> = props => {
    return (
        <ListEventView {...props} />
    )
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        text: state.calendarText
    }
}

export default connect(mapStateToProps)(ListEventBase);